const banner = document.getElementById('newsletter-popup');
const closeBtn = document.getElementById('close-btn');
if (banner && closeBtn) {
// Check cookie on load — hide if already closed
if (document.cookie.includes('bannerClosed=true')) {
  banner.style.display = 'none';
}

// Set cookie on close
closeBtn.addEventListener('click', () => {
  banner.style.display = 'none';

  // Expires in 30 days
  const expires = new Date();
  expires.setDate(expires.getDate() + 30);
  document.cookie = `bannerClosed=true; expires=${expires.toUTCString()}; path=/`;
});
}